var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNewBooking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8175 7.26083C29.7987 4.1418 36.4464 4.74866 40.7792 9.0814C45.1133 13.4155 45.1133 20.4426 40.7792 24.7767L19.6527 45.9032C19.2526 46.3032 18.604 46.3032 18.204 45.9032L2.583 30.2822C2.23769 29.9369 2.23769 29.3771 2.583 29.0318L21.7573 9.85748L26.2412 14.3414C25.1753 16.5717 25.5661 19.3243 27.4136 21.1717C29.7568 23.5149 33.5557 23.5149 35.8989 21.1717C38.242 18.8286 38.242 15.0296 35.8989 12.6865C34.0518 10.8394 31.3001 10.4483 29.07 11.5133L24.8175 7.26083Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8175 7.26083C29.7987 4.1418 36.4464 4.74866 40.7792 9.0814C45.1133 13.4155 45.1133 20.4426 40.7792 24.7767L19.6527 45.9032C19.2526 46.3032 18.604 46.3032 18.204 45.9032L2.583 30.2822C2.23769 29.9369 2.23769 29.3771 2.583 29.0318L21.7573 9.85748L26.2412 14.3414C25.1753 16.5717 25.5661 19.3243 27.4136 21.1717C29.7568 23.5149 33.5557 23.5149 35.8989 21.1717C38.242 18.8286 38.242 15.0296 35.8989 12.6865C34.0518 10.8394 31.3001 10.4483 29.07 11.5133L24.8175 7.26083Z",
    fill: "#814DE5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.1016,
    y: 21.1719,
    width: 16,
    height: 4,
    rx: 1,
    transform: "rotate(45 16.1016 21.1719)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1016,
    y: 21.1719,
    width: 16,
    height: 4,
    rx: 1,
    transform: "rotate(45 16.1016 21.1719)",
    fill: "#814DE5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.8594,
    y: 28.2427,
    width: 12,
    height: 4,
    rx: 1,
    transform: "rotate(45 11.8594 28.2427)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.8594,
    y: 28.2427,
    width: 12,
    height: 4,
    rx: 1,
    transform: "rotate(45 11.8594 28.2427)",
    fill: "#814DE5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewBooking);
export default __webpack_public_path__ + "static/media/iconNewBooking.4ab0878fc9175a1ecedd31c4d831d39e.svg";
export { ForwardRef as ReactComponent };